// @ts-nocheck
import { useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import { ArticleTeaser } from '../articleLink'
import { GlobalVariables } from 'Globals/GlobalVariables'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from '@mui/material/styles'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [articlesVqh, setarticlesVqh] = useState<string[]>([
    '636456529432',
    '987635327894',
  ])
  const [articlesTa, setarticlesTa] = useState<string[]>([
    '332096749411',
    '493132477402',
    '974028570805',
    '869136440018',
  ])
  const publisherDomain = properties?.publisherDomain
    ? properties?.publisherDomain
    : '24heures'
  const updatearticlesVqh = (e: any) => {
    const { value } = e.target
    console.log(value)
    const ids = value.split(',')
    console.log(ids)
    setarticlesVqh(ids)
  }
  const updatearticlesTa = (e: any) => {
    const { value } = e.target
    console.log(value)
    const ids = value.split(',')
    console.log(ids)
    setarticlesTa(ids)
  }
  const { palette } = createTheme()
  const { augmentColor } = palette
  const createColor = (mainColor: any) =>
    augmentColor({ color: { main: mainColor } })
  const muiTheme = createTheme({
    typography: {
      fontFamily: 'var(--font-plex)',
      htmlFontSize: 9,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: '1.5rem',
            textTransform: 'none',
            margin: '0 6px',
            whiteSpace: 'nowrap',
            borderRadius: '0',
            padding: '1rem 1rem',
          },
        },
      },
      // Custom properties for light/dark <TextField />
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            color: '#334455',
          },
          input: {
            color: colorMode === 'dark' ? '#E9E9E9' : '#334455',
            background: colorMode === 'dark' ? '#222222' : '#f2f3f4',
            border: 0,
            '&::before': {
              borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
            },
          },
          notchedOutline: {
            border: 0,
            borderColor:
              colorMode === 'dark'
                ? 'rgba(200, 200, 200, 0.23)'
                : 'rgba(0, 0, 0, 0.23)',
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            color: colorMode === 'dark' ? '#555555' : 'rgba(0, 0, 0, 0.6)',
          },
        },
      },
    },
    palette: {
      primary: {
        main:
          publisherDomain === 'tdg'
            ? colorMode === 'dark'
              ? '#5A64A8'
              : '#2c3890'
            : colorMode === 'dark'
            ? '#A34746'
            : '#d9010e',
      },
      secondary: { main: colorMode === 'dark' ? '#E9E9E9' : '#334455' },
      buttonDark:
        colorMode === 'light' ? createColor('#202346') : createColor('#6f7187'),
      buttonLight: createColor('#efece0'),
    },
  })
  return (
    <AppContainer $colorMode={colorMode}>
      <TextWidth>
        <MuiThemeProvider theme={muiTheme}>
          <Box
            component='form'
            sx={{
              '& > :not(style)': { m: 1, width: '100%' },
            }}
            noValidate
            autoComplete='off'
          >
            <TextField
              id='outlined-required'
              label='Tages-Anzeiger'
              defaultValue='332096749411,493132477402,974028570805,869136440018'
              onChange={updatearticlesTa}
            />
            <TextField
              id='outlined-required'
              label='24 heures'
              defaultValue='636456529432,987635327894'
              onChange={updatearticlesVqh}
            />
          </Box>
        </MuiThemeProvider>
      </TextWidth>
      <TextWidthExtended>
        {articlesTa.length >= 2 && (
          <>
            <h2>Articles sur tagesanzeiger.ch</h2>
            <TeaserContainer>
              <Column>
                <ArticleTeaser
                  title='Variante A'
                  ids={articlesTa.slice(0, Math.round(articlesTa.length / 2))}
                  color={colorMode === 'dark' ? '#A34746' : '#d9010e'}
                  pub='tagesanzeiger'
                />
              </Column>
              <Column>
                <ArticleTeaser
                  title='Variante B'
                  ids={articlesTa.slice(Math.round(articlesTa.length / 2))}
                  color={colorMode === 'dark' ? '#A34746' : '#d9010e'}
                  pub='tagesanzeiger'
                />
              </Column>
            </TeaserContainer>
          </>
        )}
        {articlesVqh.length >= 2 && (
          <>
            <h2>Articles sur 24heures.ch</h2>
            <TeaserContainer>
              <Column>
                <ArticleTeaser
                  title='Variante A'
                  ids={articlesVqh.slice(0, Math.round(articlesVqh.length / 2))}
                  color={colorMode === 'dark' ? '#A34746' : '#d9010e'}
                  pub='24heures'
                />
              </Column>
              <Column>
                <ArticleTeaser
                  title='Variante B'
                  ids={articlesVqh.slice(Math.round(articlesVqh.length / 2))}
                  color={colorMode === 'dark' ? '#A34746' : '#d9010e'}
                  pub='24heures'
                />
              </Column>
            </TeaserContainer>
          </>
        )}
      </TextWidthExtended>
    </AppContainer>
  )
}
const AppContainer = styled(GlobalVariables)`
  font-family: var(--font-plex);
  font-size: 1.8rem;
  line-height: 3rem;
`

const TeaserContainer = styled.div`
  display: flex;
`

const Column = styled.div`
  flex: 50%;
`

export default MainComponent
